import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CiamService } from 'src/app/services/CIAM/ciam.service';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { SafeRedirectService } from 'src/app/shared/common/safe-redirect.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const _ciamService = inject(CiamService);
  const crypto = inject(CryptoService);

  const cryptoValues = {
    USERID: crypto.getValueFromKey("USERID"),
    SUBAGENTID: crypto.getValueFromKey("SUBAGENTID"),
    SABRANCHID: crypto.getValueFromKey("SABRANCHID"),
    COMPID: crypto.getValueFromKey("COMPID"),
    ISCORPTRAVELARRANGER: crypto.getValueFromKey("ISCORPTRAVELARRANGER")
  };

  const localStorageValues = {
    token: localStorage.getItem('QlAccessToken'),
    subAgentId: localStorage.getItem('subAgentID'),
    logInDetail: localStorage.getItem('loginDetails'),
  };

  const isLoggedIn = !!(
    cryptoValues.USERID &&
    cryptoValues.SUBAGENTID &&
    cryptoValues.SABRANCHID &&
    cryptoValues.COMPID &&
    cryptoValues.ISCORPTRAVELARRANGER
  );

  const isLoggedInLocalCheck = !!(
    localStorageValues.token &&
    localStorageValues.subAgentId &&
    localStorageValues.logInDetail
  );

  // Allow navigation if either session or localStorage is valid
  if (isLoggedIn ||  ((localStorage.getItem('emailerPayload') != undefined) || (localStorage.getItem('emailerPayload') != null)  ) ) {
    return true; // normal navigation
  }

  const safeRedirect = inject(SafeRedirectService);

  // Handle login flow for not logged in users
  localStorage.setItem('returnUrl', state.url);

  if (safeRedirect.shouldRedirectToLogin(state.url)) {
    return router.createUrlTree(['/login-landing']);
  }
  
  return router.createUrlTree(['/']);
};